<template>
  <div class="container not-found-page ">
    <div class="not-found-page">
      <h1>404</h1>
      <img src="https://offthecouch.io/img/pandas/search.png">
      <p class="mt-4">{{$t('general.notFound')}}</p>
    </div>
  </div>
</template>

<script>

export default {
  methods: {
  },
};
</script>
<style scoped>
.not-found-page {
  min-height: calc(120vh - 160px);
  display: flex;
  padding-bottom: 150px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
}
</style>
